import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import fontService, { FontWeight, TextType } from 'services/FontService';
import { Colors } from 'context';

interface IGrowthCareerInvite {
  /** Куда ведёт кнопка — адрес школы приходит с сервера вместе с постом. */
  siteUrl: string;
}

/**
 * Приглашение в карьерный центр (ТЗ 0039, доводка).
 *
 * 🔴 Показывается ТОЛЬКО тому, кто в центр не входит. До этого блока такой
 * студент видел три медали с замком «доступно участникам центра» — и нигде на
 * всём экране не было сказано, что это за центр, что он даёт и как туда
 * попасть. Замок дразнил, но не продавал: худший из возможных исходов для
 * продающей поверхности.
 */
export const GrowthCareerInvite = memo(({ siteUrl }: IGrowthCareerInvite) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Title>{t('growth.invite.title')}</Title>
      <Text>{t('growth.invite.text')}</Text>
      <List>
        <li>{t('growth.invite.point1')}</li>
        <li>{t('growth.invite.point2')}</li>
        <li>{t('growth.invite.point3')}</li>
      </List>
      <Footer>{t('growth.invite.how')}</Footer>
      {siteUrl ? (
        <Action href={siteUrl} target="_blank" rel="noopener noreferrer">
          {t('growth.invite.action')}
        </Action>
      ) : null}
    </Card>
  );
});

const Card = styled.section`
  padding: 20px 24px;
  border-radius: 12px;
  border: 1px dashed ${Colors.main};
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Title = styled.h2`
  margin: 0;
  ${fontService.text({ type: TextType.medium, weight: FontWeight.bold })}
`;

const Text = styled.p`
  margin: 0;
  color: ${Colors.gray_dark};
  ${fontService.text({ type: TextType.small })}
`;

const List = styled.ul`
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${fontService.text({ type: TextType.small })}
`;

const Footer = styled.p`
  margin: 0;
  color: ${Colors.gray_dark};
  ${fontService.text({ type: TextType.extraSmall })}
`;

const Action = styled.a`
  align-self: flex-start;
  padding: 8px 18px;
  border-radius: 8px;
  background: ${Colors.main};
  color: ${Colors.btn_text};
  text-decoration: none;
  ${fontService.text({ type: TextType.small, weight: FontWeight.medium })}
`;
